export default __webpack_public_path__ + "static/media/arrow-down.0b7657b1.svg";